import React from "react";
// Import CSS stylesheets
import "../styles/variables.css";
import "../styles/layoutStyles.css";
import "../styles/buttonStyles.css";

interface DropdownMenuProps {
  onAccountClick: () => void;
  onSignOut: () => void;
}

function DropdownMenu({ onAccountClick, onSignOut }: DropdownMenuProps) {
  return (
    <div className="box-sizing-default">
      <div className="box-sizing-default top-bar-dropdown-menu">
        <button onClick={onAccountClick}>Account</button>
        <button onClick={onSignOut}>Sign out</button>
      </div>
    </div>
  );
}

export default DropdownMenu;
